/*
 * @Author: Ygm
 * @Date: 2023-03-29 20:04:17
 * @LastEditors: Ygm
 * @LastEditTime: 2023-03-29 20:06:00
 * @Description: H5与原生交互桥梁文件
 */
// 这里根据移动端原生的 userAgent 来判断当前是 Android 还是 ios
const u = navigator.userAgent
// Android终端
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
// IOS 终端
const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

/**
 * 配合 IOS 使用时的初始化方法
 */
// const iosFunction = (callback) => {
//     if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge) }
//     if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback) }
//     window.WVJBCallbacks = [callback];
//     var WVJBIframe = document.createElement('iframe');
//     WVJBIframe.style.display = 'none';
//     WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
//     document.documentElement.appendChild(WVJBIframe);
//     setTimeout(function(){
//         document.documentElement.removeChild(WVJBIframe);
//     }, 0);
// }

/**
 * 配合 Android 使用时的初始化方法
 */
const androidFunction = callback => {
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge)
  } else {
    document.addEventListener(
      'WebViewJavascriptBridgeReady',
      function() {
        callback(window.WebViewJavascriptBridge)
      },
      false
    )
  }
}

// window.setupWebViewJavascriptBridge = isAndroid ? androidFunction : iosFunction;
window.setupWebViewJavascriptBridge = androidFunction

isAndroid &&
window.setupWebViewJavascriptBridge(function(bridge) {
  // 注册 H5 界面的默认接收函数（与安卓交互时，安卓端可以不调用函数名，直接 send 数据过来，就能够在这里接收到数据）
  bridge.init(function(msg, responseCallback) {
    console.log(msg)
    responseCallback('JS 返回给原生的消息内容')
  })
})

function androidBack (pkg = 'AndroidBack') {
  var STATE = '_android_back'
  // 维护处理方法的栈
  var _android_back_handles = []
  // 触发一次popstate方法，则调用最新处理方法
  var handlePopstate = function() {
    var handle = _android_back_handles.pop()
    handle && handle()
  }
  // 通过调用listen方法添加处理方法
  var listen = function(handle) {
    _android_back_handles.push(handle)
  }
  // 通过调用push方法，新增一条历史记录，并添加对应处理方法
  var push = function(state, handle) {
    if (handle) {
      history.pushState(state, null, location.href)
      handle && _android_back_handles.push(handle)
    }
  }
  const init = function() {
    // 通过调用 history.pushState() 方法添加一条历史记录
    history.pushState(STATE, null, location.href)
    // 监听 popstate 事件，当点击Android物理返回键时，会触发该事件
    window.addEventListener('popstate', handlePopstate)
    this.listen = listen
    this.push = push
  }
  init.call((window[pkg] = window[pkg] || {}))
}

androidBack()

/*
    window.setupWebViewJavascriptBridge(bridge => {
        bridge.registerHandler('事件函数名',fun 执行函数);
    })
*/
// window.setupWebViewJavascriptBridge(bridge => {
//     /**
//      * data：原生传过来的数据
//      * fn: 原生传过来的回调函数
//      */
//     bridge.registerHandler("H5Function", (data, fn) => {
//         console.log(data);
//         fn && fn();
//     });
// });



// WEBPACK FOOTER //
// ./src/utils/jsBridge.js